<template>
  <div class="recommend-schemes">
    <el-radio-group :value="selected" @input="onSelect">
      <div
        v-for="(scheme, index) in schemes"
        :key="'scheme-' + index"
        class="recommend-scheme"
        :class="{ 'is-selected': selected === index }"
        @click="onSelect(index)"
      >
        <div class="recommend-scheme-head">
          <el-radio :label="index" class="recommend-scheme-radio">
            <span class="recommend-scheme-name">{{ scheme.name }}</span>
          </el-radio>
        </div>
        <div class="recommend-scheme-desc">{{ scheme.description }}</div>
        <div class="recommend-scheme-rule">
          <span class="recommend-scheme-label">关键词</span>
          <span>{{ formatSchemeGroups(scheme) }}</span>
        </div>
        <div class="recommend-scheme-rule">
          <span class="recommend-scheme-label">排除词</span>
          <span>{{ formatSchemeExcludeWords(scheme) }}</span>
        </div>
        <div v-if="scheme.duplicateTaskName" class="recommend-scheme-dup">
          <i class="el-icon-warning-outline"></i> 已有相同规则的在跑任务「{{ scheme.duplicateTaskName }}」
        </div>
      </div>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'KeywordRecommendSchemes',
  props: {
    schemes: {
      type: Array,
      default() {
        return []
      }
    },
    selected: {
      type: Number,
      default: -1
    }
  },
  methods: {
    onSelect(index) {
      this.$emit('update:selected', index)
    },
    formatSchemeGroups(scheme) {
      const groups = scheme && Array.isArray(scheme.keywordGroups) ? scheme.keywordGroups : []
      return groups
        .map(words => '（' + (words || []).join(' 或 ') + '）')
        .join(' 且 ')
    },
    formatSchemeExcludeWords(scheme) {
      const words = scheme && Array.isArray(scheme.excludeWords) ? scheme.excludeWords : []
      return words.length ? words.join('、') : '无'
    }
  }
}
</script>

<style>
.recommend-schemes {
  max-height: 380px;
  overflow-y: auto;
}

.recommend-schemes .el-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.recommend-scheme {
  border: 1px solid #e4e9f2;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.recommend-scheme:hover {
  border-color: #b6c4ff;
}

.recommend-scheme.is-selected {
  border-color: #2f5bff;
  background: #f5f8ff;
}

.recommend-scheme-head {
  display: flex;
  align-items: center;
}

.recommend-scheme-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2d3d;
}

.recommend-scheme-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}

.recommend-scheme-rule {
  margin-top: 6px;
  font-size: 12px;
  color: #1f2d3d;
  line-height: 1.6;
}

.recommend-scheme-label {
  display: inline-block;
  min-width: 48px;
  color: #94a3b8;
}

.recommend-scheme-dup {
  margin-top: 6px;
  font-size: 12px;
  color: #e6a23c;
}
</style>
